import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../store/slices/authSlice';
import { authAPI } from '../services/api';

/**
 * Handles the Google OAuth implicit-flow redirect.
 * URL fragment contains: #access_token=...&id_token=...&token_type=Bearer&...
 */
const GoogleCallback: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState('');

  useEffect(() => {
    const processCallback = async () => {
      try {
        // Parse the hash fragment
        const hash = window.location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const idToken = params.get('id_token');

        if (!idToken) {
          setError('No ID token received from Google. Please try again.');
          setTimeout(() => navigate('/login'), 3000);
          return;
        }

        // Send the ID token to our backend
        const result = await authAPI.loginWithGoogle(idToken);
        dispatch(setCredentials({ user: result.data.user, token: result.data.token }));
        navigate('/');
      } catch (err: any) {
        setError(err.response?.data?.error || 'Google Sign-In failed. Please try again.');
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    processCallback();
  }, [navigate, dispatch]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#0f0f1a',
      color: '#fff',
      flexDirection: 'column',
      gap: '16px',
    }}>
      {error ? (
        <>
          <p style={{ color: '#ef4444', fontSize: '16px' }}>{error}</p>
          <p style={{ color: '#a0aec0', fontSize: '14px' }}>Redirecting to login...</p>
        </>
      ) : (
        <>
          <div style={{
            width: '40px',
            height: '40px',
            border: '3px solid rgba(102, 126, 234, 0.3)',
            borderTopColor: '#667eea',
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
          }} />
          <p style={{ color: '#a0aec0', fontSize: '16px' }}>Signing in with Google...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </>
      )}
    </div>
  );
};

export default GoogleCallback;
